<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { getCheckOutcomeChipDisplay } from '@satellite/helpers/yardTaskUtils';

import type { CheckTaskViewData } from '@nova/core';

const props = defineProps<{
  task: CheckTaskViewData;
}>();

const { t } = useI18n();

const kind = computed(() => getCheckOutcomeChipDisplay(props.task));

const iconName = computed(() => {
  if (kind.value === 'confirmed') return 'mdi-clipboard-check-outline';
  if (kind.value === 'missing') return 'mdi-clipboard-remove-outline';
  return 'mdi-clipboard-outline';
});

const iconColor = computed(() => {
  if (kind.value === 'confirmed') return 'success';
  if (kind.value === 'missing') return 'error';
  return undefined;
});

const label = computed(() => (kind.value ? t(`checkTaskDetails.outcome.${kind.value}`) : ''));
</script>

<template>
  <div v-if="kind" class="d-flex align-center gap-1">
    <v-icon :icon="iconName" :color="iconColor ?? 'neutral-80'" size="16" />
    <span class="typography-body-sm">{{ label }}</span>
  </div>
</template>
